<template>
	<div
		class="statistics-flaw-panel"
		:class="panelClass"
	>
		<div class="statistics-panel-title">
			<div class="list-title">{{ $t('statistics.flaws') }}</div>
			<button
				type="button"
				class="statistics-panel-expand-button"
				:title="expandTitle"
				@click="$emit('toggle-expand')"
			>
				<i class="fas" :class="isExpanded ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
			</button>
		</div>
		<div v-if="selectedItem">
			<p class="statistics-muted detail-subtitle">
				{{ getInventoryName(selectedItem) }}
			</p>
			<div class="statistics-map-action">
				<button
					type="button"
					class="button is-primary is-small"
					:disabled="selectedItem.isLooseFlaw"
					@click="$emit('open-map', selectedItem)"
				>
					<i class="fas fa-map"></i>
					<span>{{ $t('statistics.show_drawing') }}</span>
				</button>
				<p v-if="selectedItem.isLooseFlaw" class="statistics-muted">
					{{ $t('statistics.loose_flaw_missing_inventory_link') }}
				</p>
			</div>
			<div class="statistics-map-preview">
				<div class="statistics-map-title">
					{{ getInventoryMapTitle(selectedItem) }}
				</div>
				<div v-if="mapLoading" class="statistics-empty compact">
					{{ $t('statistics.loading_drawing') }}
				</div>
				<div v-else-if="mapImage && hasInventoryMapPosition(selectedItem)" class="statistics-map-canvas">
					<img
						:src="mapImage"
						:alt="getInventoryMapTitle(selectedItem)"
						draggable="false"
					/>
					<div
						class="statistics-map-marker"
						:style="getInventoryMapMarkerStyle(selectedItem)"
						:title="getInventoryName(selectedItem)"
					>
						<div
							class="statistics-map-inventory-icon"
							:class="getInventoryMapIconClass(selectedItem)"
						></div>
					</div>
				</div>
				<div v-else class="statistics-empty compact">
					{{ mapError || $t('statistics.drawing_or_position_missing') }}
				</div>
			</div>
			<div class="panel-list-header statistics-flaw-header">
				<div class="panel-header-item">{{ $t('statistics.flaw') }}</div>
				<div class="panel-header-item flaw-date">{{ $t('statistics.created') }}</div>
				<div class="panel-header-item flaw-status">{{ $t('statistics.status') }}</div>
			</div>
			<div
				v-for="flaw in flaws"
				:key="flaw.id || flaw.name"
				class="panel-list statistics-flaw-row"
			>
				<div class="panel-list-item flaw-name">
					{{ getFlawName(flaw) }}
				</div>
				<div class="panel-list-item flaw-date">
					{{ flaw.created ? $utils.date.getFullDate(flaw.created) : '-' }}
				</div>
				<div class="panel-list-item flaw-status">
					{{ flaw.done ? $t('statistics.resolved') : $t('statistics.not_resolved') }}
				</div>
			</div>
			<div v-if="!flaws.length" class="statistics-empty compact">
				{{ $t('statistics.no_flaws_for_inventory_period') }}
			</div>
		</div>
		<div v-else class="statistics-empty compact">
			{{ $t('statistics.select_inventory_to_view_flaws') }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatisticsFlawPanel',

	props: {
		expandTitle: {
			type: String,
			required: true
		},
		flaws: {
			type: Array,
			default: () => []
		},
		getFlawName: {
			type: Function,
			required: true
		},
		getInventoryMapIconClass: {
			type: Function,
			required: true
		},
		getInventoryMapMarkerStyle: {
			type: Function,
			required: true
		},
		getInventoryMapTitle: {
			type: Function,
			required: true
		},
		getInventoryName: {
			type: Function,
			required: true
		},
		hasInventoryMapPosition: {
			type: Function,
			required: true
		},
		isExpanded: {
			type: Boolean,
			default: false
		},
		mapError: {
			type: String,
			default: ''
		},
		mapImage: {
			type: String,
			default: ''
		},
		mapLoading: {
			type: Boolean,
			default: false
		},
		panelClass: {
			type: [String, Object, Array],
			default: ''
		},
		selectedItem: {
			type: Object,
			default: null
		}
	}
};
</script>
